'use client';

import type { ReactNode } from 'react';
import { useInView } from 'react-intersection-observer';
import { MobileCarousel } from './mobile-carousel';
interface ResponsiveGridCarouselProps {
  items: ReactNode[];
  gridCols?: {
    md?: number;
    lg?: number;
  };
  className?: string;
  gridClassName?: string;
  carouselClassName?: string;
  slideClassName?: string;
}
export const ResponsiveGridCarousel = ({
  items,
  gridCols = {
    md: 2,
    lg: 4
  },
  className = '',
  gridClassName = '',
  carouselClassName = '',
  slideClassName = ''
}: ResponsiveGridCarouselProps) => {
  const {
    ref,
    inView
  } = useInView({
    triggerOnce: true,
    threshold: 0,
    rootMargin: '1200px 0px'
  });
  if (!items || items.length === 0) {
    return null;
  }
  const animationClasses = `transition-all duration-1000 ease-out ${inView ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`;
  return <div ref={ref} className={className} data-sentry-component="ResponsiveGridCarousel" data-sentry-source-file="responsive-grid-carousel.tsx">
      {/* Mobile carousel view */}
      <div className="md:hidden bg-gray-50 py-6">
        <div className="container mx-auto">
          <MobileCarousel items={items} className={`${animationClasses} ${carouselClassName}`} slideClassName={slideClassName} data-sentry-element="MobileCarousel" data-sentry-source-file="responsive-grid-carousel.tsx" />
        </div>
      </div>

      {/* Desktop grid view */}
      <div className={`hidden md:grid gap-4 container mx-auto ${animationClasses} ${gridCols.lg ? `md:grid-cols-${gridCols.md} lg:grid-cols-${gridCols.lg}` : `md:grid-cols-${gridCols.md}`} ${gridClassName}`}>
        {items.map((item, index) => <div key={index}>{item}</div>)}
      </div>
    </div>;
};